var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongoose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "62.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 62.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265 231 c-2 -5 -27 -11 -53 -13 -53 -5 -120 -34 -165 -70 l-28 -23 64 0 c50 0 70 -4 86 -19 21 -19 21 -19 21 2 0 30 42 30 62 0 l15 -22 12 22 c7 14 21 22 36 22 22 0 25 -4 25 -41 0 -39 0 -40 22 -25 12 9 37 16 56 16 18 0 31 4 27 10 -6 9 35 22 107 34 32 6 58 28 58 50 0 3 -39 17 -87 32 -87 27 -247 42 -258 25z m52 -33 c6 -5 9 -16 6 -24 -5 -13 -8 -12 -24 2 -37 33 -21 52 18 22z m-27 -33 l25 -30 -27 24 c-16 14 -28 29 -28 34 0 6 1 8 3 6 1 -2 13 -17 27 -34z m185 25 c18 -8 17 -9 -7 -9 -15 -1 -30 4 -33 9 -7 12 12 12 40 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 43 c0 -29 3 -33 25 -33 20 0 25 5 25 26 0 22 -3 24 -14 15 -11 -10 -17 -8 -25 6 -9 15 -10 13 -11 -14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoose);
export default __webpack_public_path__ + "static/media/mongoose.4fb7495f6877c4164108c78c51fc2e0b.svg";
export { ForwardRef as ReactComponent };